import React, { useState } from 'react'
import { apiGet } from '../../../generic/Api_Functions'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { DefaultAccordion } from '../../../generic/DefaultAccordion'
import { useSmartInterval } from '../../../generic/hooks/useSmartInterval'
import { Stack, Typography } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'
import TaskReference from './TaskReference'

/**
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/FabricationOrder").FabricationOrder} FabricationOrder Fabrication Order object
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/LinkedJobReference").LinkedJobReference} LinkedJobReference Linked Job Reference object
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/TaskReference").TaskReference} TaskReference Task Reference object
*/

/**
 * @param {Object} props
 * @param {FabricationOrder} props.fabricationOrder
 * @param {LinkedJobReference} props.linkedJobReference
 * @returns
 */
const LinkedJobReference = ({ fabricationOrder, linkedJobReference }) => {
  const { t_ } = useSmartTranslation()
  /** @type {[TaskReference[],  React.Dispatch<SetStateAction<TaskReference[]>>]} */
  const [taskReferences, setTaskReferences] = useState(null)
  const [expandedAccordion, setExpandedAccordion] = useState(false)

  const taskReferenceInterval = useSmartInterval(
    async () => {
      return await apiGet('toolTable/fabricationOrder/' + fabricationOrder.id + '/linkedJobReference/' + linkedJobReference.id + '/taskReferences')
    },
    2000,
    (data) => {
      if (data != null) {
        setTaskReferences(data)
      }
    }, false)

  const getLinkedJobReference = () => {
    return (
      <>
        <Stack direction='row' gap={20}>
          <Typography sx={{ minWidth: '15rem' }}>{t_('Job') + ': ' + linkedJobReference.name}</Typography>
          <Stack direction='row'>
            <Typography>{t_('Pending parts') + ': ' + linkedJobReference.pendingParts}</Typography>
          </Stack>
        </Stack>
        <Stack>
          <ConstructionIcon color={linkedJobReference.toolsOk ? 'primary' : 'error'} />
        </Stack>
      </>
    )
  }

  return (
    <DefaultAccordion
      key={linkedJobReference.id}
      onExpandedStatusChange={(expanded) => {
        if (expanded !== expandedAccordion) {
          taskReferenceInterval(expanded)
          setExpandedAccordion(expanded)
        }
      }}
      headerRender={getLinkedJobReference()}
      defaultExpanded={false}
      headerSx={{ backgroundColor: theme => theme.palette.background.paper }}
      contentSx={{ backgroundColor: theme => theme.palette.background.paper }}
    >
      {
      expandedAccordion
        ? taskReferences?.map((taskReference) => {
          return (
            <TaskReference
              key={taskReference.id}
              fabricationOrder={fabricationOrder}
              linkedJobReference={linkedJobReference}
              taskReference={taskReference}
            />
          )
        })
        : null
      }
    </DefaultAccordion>
  )
}

export default LinkedJobReference
